// extracted by mini-css-extract-plugin
module.exports = {"dotBase":"Dot_dotBase__2Wmd8","dotLarge":"Dot_dotLarge__3rfN_"};